import React from 'react';
import { Drawer, Form, Input, Button, Select } from 'antd';
import withStyles from 'react-jss';
import { StylesProps } from 'src/library/types';
import { FilterUsersDrawerStyles } from './FilterUsersDrawer.styles';

interface IProps extends StylesProps<ReturnType<typeof FilterUsersDrawerStyles>> {
  isVisible: boolean;
  handleClose: () => void;
  t: (key: string) => string;
  onApply: (values: any) => void;
  initialFilters: any;
}

const FilterUsersDrawer = (props: IProps): React.ReactElement => {
  const { classes, isVisible, handleClose, t, onApply, initialFilters } = props;
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (isVisible) {
      form.resetFields();
      form.setFieldsValue(initialFilters);
    }
  }, [isVisible, initialFilters, form]);

  const handleApply = () => {
    form
      .validateFields()
      .then((values) => {
        onApply(values);
        handleClose();
      })
      .catch(() => null);
  };

  return (
    <Drawer
      title={t('Filter Users')}
      width={380}
      visible={isVisible}
      onClose={handleClose}
      destroyOnClose
      placement="right"
    >
      <div className={classes.drawerContent}>
        <Form layout="vertical" form={form}>
          <Form.Item label={t('City')} name="city">
            <Input placeholder={t('Enter City')} />
          </Form.Item>
          <Form.Item label={t('Phone Number')} name="phone">
            <Input placeholder={t('Enter 10 Digit Phone Number')} maxLength={10} />
          </Form.Item>
          <Form.Item label={t('Status')} name="status">
            <Select placeholder={t('Select Status')}>
              <Select.Option value="active">{t('Active')}</Select.Option>
              <Select.Option value="inactive">{t('Inactive')}</Select.Option>
            </Select>
          </Form.Item>
          <div className={classes.buttonRow}>
            <Button type="primary" onClick={handleApply}>
              {t('Apply')}
            </Button>
          </div>
        </Form>
      </div>
    </Drawer>
  );
};

export default withStyles(FilterUsersDrawerStyles)(FilterUsersDrawer);
